import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo is joining Vercel",
  "description": "Turborepo is joining Vercel to make the web even faster.",
  "date": "2021/12/09",
  "tag": "web development",
  "ogImage": "/images/blog/joining-vercel/x-card.png"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo has been acquired by Vercel and the Turborepo CLI is now open-source! Also, Turborepo now provides zero-config remote caching through Vercel!"
  }, {
    "heading": "",
    "content": "beta.turborepo.com and its remote caching service will be shut down on January 15th, 2022 and older versions of the turbo CLI will not be installable."
  }, {
    "heading": "",
    "content": "This is a milestone moment for the project and for all of you who have supported and adopted Turborepo. With Vercel's infrastructure and team backing, I'll expand on the capabilities of Turborepo and build out a team focused on improving their world-class build system. I can't wait to bring you along for this next chapter."
  }, {
    "heading": "",
    "content": "Join me this Friday, December 10 at 4:00 p.m. ET | 9:00 p.m GMT for a livestream Q&A with Vercel's Head of Developer Relations, Lee Robinson. We'll go over what's in store for Turborepo and Vercel as we work toward improving the developer experience together."
  }, {
    "heading": "",
    "content": "This is just the beginning. We're about to embark on a world of even faster builds, even more flexibility, and even better workflows. Thanks for joining us on this amazing journey."
  }],
  "headings": []
};
import {Authors} from '#components/authors';
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    p: "p",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo is joining Vercel"
    }), "\n", "\n", _jsx(Authors, {
      authors: ['jaredpalmer']
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo has been acquired by Vercel and the Turborepo CLI is now open-source! Also, Turborepo now provides zero-config remote caching through ", _jsx(_components.a, {
        href: "https://vercel.com/?utm_source=turborepo.com&utm_medium=referral&utm_campaign=docs-link",
        children: "Vercel"
      }), "!"]
    }), "\n", _jsxs(_components.p, {
      children: ["beta.turborepo.com and its remote caching service will be shut down on January 15th, 2022 and older versions of the ", _jsx(_components.code, {
        children: "turbo"
      }), " CLI will not be installable."]
    }), "\n", _jsxs(_components.p, {
      children: ["This is a milestone moment for the project and for all of you who have supported and adopted Turborepo. With Vercel's infrastructure and team backing, I'll expand on the capabilities of Turborepo and build out a team focused on improving their world-class build system. I can't wait to bring you along for this ", _jsx(_components.a, {
        href: "https://vercel.com/blog/vercel-acquires-turborepo",
        children: "next chapter"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Join me this ", _jsx(_components.a, {
        href: "https://www.youtube.com/watch?v=YX5yoApjI3M",
        children: "Friday, December 10 at 4:00 p.m. ET | 9:00 p.m GMT for a livestream Q&A"
      }), " with Vercel's Head of Developer Relations, Lee Robinson. We'll go over what's in store for Turborepo and Vercel as we work toward improving the developer experience together."]
    }), "\n", _jsx(_components.p, {
      children: "This is just the beginning. We're about to embark on a world of even faster builds, even more flexibility, and even better workflows. Thanks for joining us on this amazing journey."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
